import CuFooter from './Cu-Footer.vue';

export default CuFooter;


// WEBPACK FOOTER //
// ./src/packages/Footer/CuFooter/index.js